/* eslint-disable */
import React from "react"
import {Link} from "react-router-dom"
import "../styles/ArticleList.css";
import GuideItem from "./GuideItem";

class GuideList extends React.Component {
  // state = this.props.articles;
  state = [];
  render() {
    return (
      <div className="list">
        <h3 className="widget-title">{this.props.title}
          <Link className="button fancy-button widget-arrow"
            to="/"><i className="material-icons">skip_next</i></Link>
        </h3>
        <div className="article-item-list">
          <div className="container">
            <GuideItem article={{title:"Canadian Venue Profiles",slug:"venues"}} />
            <GuideItem article={{title:"Canadian Music Festival Profiles",slug:"fests"}} />
            <GuideItem article={{title:"Canadian Music Festival Listings",slug:"festivals"}} />
          </div>
        </div>
      </div>
    )
  }


}
export default GuideList
